import { SVGProps } from 'react';

export const UndoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 154 127" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.80758 21.9573C-1.26905 25.0812 -1.26904 32.4604 3.80759 35.5842L37.5423 56.3423C42.8725 59.6221 49.7349 55.7873 49.7349 49.5289V8.01263C49.7349 1.75419 42.8725 -2.08063 37.5423 1.1992L3.80758 21.9573Z"
        fill="currentColor"
      />
      <path
        d="M50.738 119.77C50.738 119.77 71.7356 119.771 74.2356 119.77C76.7356 119.769 40.2363 119.771 84.7356 119.771C129.235 119.771 146.738 113.771 146.738 75.2697C146.738 36.7686 130.238 28.2697 87.738 28.2697H50.738"
        stroke="currentColor"
        strokeWidth="14"
        strokeLinecap="round"
      />
    </svg>
  );
};
